module.exports = __webpack_public_path__ + "93cfd8a488b55e8271a78fb3d0b8f7c8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-ranger-s.png
// module id = 2278
// module chunks = 0